import { CheckableItem, ToggleCheck } from "@shared/common/hooks/selectionState";
import { Checkbox } from "@shared/EDS/components/Checkbox";
import { ReactElement } from "react";

interface SBDTrackFilterProps {
  readonly filters: CheckableItem[];
  readonly toggleFilter: ToggleCheck;
  readonly setAllChecked: () => void;
  readonly setAllUnchecked: () => void;
}

export function SBDTrackFilter({
  filters,
  toggleFilter,
  setAllChecked,
  setAllUnchecked,
}: SBDTrackFilterProps): ReactElement {
  const allChecked = filters.every(({ isChecked }) => isChecked);
  const noneChecked = filters.every(({ isChecked }) => !isChecked);
  const selectAllChecked = allChecked ? true : noneChecked ? false : "indeterminate";

  return (
    <ul className="p-0">
      <li className="my-s list-none">
        <Checkbox
          label="Selecteer alles"
          isChecked={selectAllChecked}
          onCheckedChange={() => (allChecked ? setAllUnchecked() : setAllChecked())}
        />
      </li>
      {filters.map(({ name, isChecked }) => (
        <li key={`SBDTrackFilter-${name}`} className="my-s list-none">
          <Checkbox label={name} isChecked={isChecked} onCheckedChange={() => toggleFilter(name)} />
        </li>
      ))}
    </ul>
  );
}
